"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _InteractionWithValidatedAttachmentsComponentConfig = _interopRequireDefault(require("customer-data-communicator/schema/wrappers/InteractionWithValidatedAttachmentsComponentConfig"));

var _GenericPluginGroup = _interopRequireDefault(require("draft-plugins/plugins/GenericPluginGroup"));

var _AttachmentPlugin = _interopRequireDefault(require("customer-data-rte/plugins/AttachmentPlugin"));

var _FileManagerAttachmentPlugin = _interopRequireDefault(require("customer-data-rte/plugins/FileManagerAttachmentPlugin"));

var _AttachmentThumbnailUrlConfig = _interopRequireDefault(require("customer-data-communicator/data/attachments/AttachmentThumbnailUrlConfig"));

var _default = new _InteractionWithValidatedAttachmentsComponentConfig.default({
  GenericPluginGroup: _GenericPluginGroup.default,
  AttachmentPlugin: _AttachmentPlugin.default,
  FileManagerAttachmentPlugin: _FileManagerAttachmentPlugin.default,
  thumbnailUrlConfig: _AttachmentThumbnailUrlConfig.default
});

exports.default = _default;
module.exports = exports.default;